
;"use strict";

var State = {

// Глобальные флаги тестовой модификации

	flTrace: 0, // Флаг включения трассировки

/////////////////////////////////////////

	dbVersion: 2, // версия хранилища в local storage

	super: 1072427180, // пароль суперпользователя

	startEvent: 'mousedown',
	currPage: 0,
	flSelection: 0,
	flModal: 0,
	flIpad: 0,
	flAnimate: 0,
	regionDataInit: 0, // Индикатор первой инициализации выбранного региона
	currRegname: '',
	currRegNum: 0,

	dsList: [
		'ds23.001',
		'ds35.001',
		'ds35.002',
		'ds36.006',
		'ds36.008',
		'ds36.009',
		'ds36.010'
	],

	stList: [
		'st12.015',
		'st12.016',
		'st12.017',
		'st12.018',
		'st12.019',
		'st23.005',
		'st27.011',
		'st35.001',
		'st35.002',
		'st36.012',
		'st36.017',
		'st36.018',
		'st36.019'
	],


	dsBuf: {
		'ds23.001': 0,
		'ds35.001': 0,
		'ds35.002': 0,
		'ds36.006': 0,
		'ds36.008': 0,
		'ds36.009': 0,
		'ds36.010': 0
	},

	stBuf: {
		'st12.015': 0,
		'st12.016': 0,
		'st12.017': 0,
		'st12.018': 0,
		'st12.019': 0,
		'st23.005': 0,
		'st27.011': 0,
		'st35.001': 0,
		'st35.002': 0,
		'st36.012': 0,
		'st36.017': 0,
		'st36.018': 0,
		'st36.019': 0
	}
}

export default State;